import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Dashboard from './components/Dashboard';
import CandidateEvaluation from './components/CandidateEvaluation';
import CandidateEvaluations from './components/CandidateEvaluations';
import SubmissionsList from './components/SubmissionsList';
import Analytics from './components/Analytics';
import Reports from './components/Reports';
import GuidelinesManager from './components/GuidelinesManager';
import GroundTruthExplainer from './components/GroundTruthExplainer';
import ScorePatternDiscovery from './components/ScorePatternDiscovery';
import AppLayout from './components/Layout/AppLayout';
import Login from './components/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/candidate/:candidateId" element={<ProtectedRoute><CandidateEvaluation /></ProtectedRoute>} />
      <Route path="/candidate-detail/:candidateId" element={<ProtectedRoute><CandidateEvaluations /></ProtectedRoute>} />
      <Route path="/submissions" element={<ProtectedRoute><SubmissionsList /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/guidelines" element={<ProtectedRoute><GuidelinesManager /></ProtectedRoute>} />
      <Route path="/ground-truth-explain" element={<ProtectedRoute><GroundTruthExplainer /></ProtectedRoute>} />
      <Route path="/score-pattern-discovery" element={<ProtectedRoute><ScorePatternDiscovery /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout>
          <AppRoutes />
        </AppLayout>
      </Router>
    </AuthProvider>
  );
}

export default App;
